"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function TargetCursor24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("g", { id: "target-cursor-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M12,12 L21,20 L15.7675781,20 L12,24 L12,12 Z M12,2 C17.5228475,2 22,6.4771525 22,12 C22,13.8746703 21.4841475,15.6288568 20.586646,17.1283558 L20.5910645,17 L19.1614471,15.5695662 C19.6980885,14.4950137 20,13.2827645 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,15.7279108 6.54986283,18.8602692 10.000644,19.7481308 L10.0000191,21.7999676 C5.43552894,20.8734344 2,16.8379226 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,6 C15.3137085,6 18,8.6862915 18,12 C18,12.7196019 17.8733197,13.4096161 17.6410436,14.0489579 L15.9812505,12.3897892 C15.9936537,12.2615347 16,12.1315085 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 C8,13.480515 8.80434324,14.7731656 9.99987956,15.4648015 L10.0003218,17.6587023 C7.66976896,16.8351204 6,14.6125579 6,12 C6,8.6862915 8.6862915,6 12,6 Z", id: "Combined-Shape", fill: "#000000" })));
}
function TargetCursor24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(TargetCursor24Svg, Object.assign({}, svgProps)));
}
exports.default = TargetCursor24;
//# sourceMappingURL=TargetCursor24.js.map